import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { map } from 'rxjs';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { BulkUploadService } from '../services/bulk-upload.service';

@Component({
  selector: 'app-bulk-upload-drop',
  templateUrl: './bulk-upload-drop.component.html',
  styleUrls: ['./bulk-upload-drop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadDropComponent {
  @ViewChild('fileUpload') fileUpload?: ElementRef<HTMLInputElement>;

  protected readonly IconTypes = IconTypes;
  readonly config = this.bulkUploadService.config;
  readonly errorMessage$ = this.bulkUploadService.errorMessage$;
  readonly selectedFileName$ = this.bulkUploadService.selectedSingleNonPdfFile$.pipe(
    map((file) => file?.name),
  );
  readonly showSelectedState$ = this.bulkUploadService.selectedSingleNonPdfFile$.pipe(
    map((file) => file !== undefined),
  );

  constructor(private readonly bulkUploadService: BulkUploadService) {}

  handleInputChange(event: Event) {
    const target = event.target as HTMLInputElement | null;
    if (target?.files?.length) {
      this.bulkUploadService.addFiles(Array.from(target.files));
    }
    if (target) {
      target.value = '';
    }
  }

  handleDrop(files: FileList) {
    if (files?.length) {
      this.bulkUploadService.addFiles(Array.from(files));
    }
  }

  openFilePicker() {
    this.fileUpload?.nativeElement.click();
  }
}
